import { render, staticRenderFns } from "./OpinionMediaTop5.vue?vue&type=template&id=f59f2d40"
import script from "./OpinionMediaTop5.vue?vue&type=script&lang=js"
export * from "./OpinionMediaTop5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports